import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let Background = class Background extends Vue {
    constructor() {
        super(...arguments);
        this.lazyImg = {
            imgObj: {
                src: this.src,
                error: 'https://firebasestorage.googleapis.com/v0/b/menu-digital-desarrollo.appspot.com/o/icons%2Fbeebot.png?alt=media&token=b7d888e3-db42-43bb-a158-a521e2895e75',
                loading: 'https://firebasestorage.googleapis.com/v0/b/menu-digital-desarrollo.appspot.com/o/icons%2Floader-bee.gif?alt=media&token=b5374c8d-da65-4a89-a448-16aa2c837bf0'
            },
        };
    }
    get letters() {
        return this.name && !this.src ? this.name.charAt(0).toUpperCase() : "";
    }
};
__decorate([
    Prop({ default: "" })
], Background.prototype, "src", void 0);
__decorate([
    Prop({ default: "" })
], Background.prototype, "name", void 0);
__decorate([
    Prop({ default: "50px" })
], Background.prototype, "size", void 0);
Background = __decorate([
    Component
], Background);
export default Background;
